import { AccessManagementUserAuthContext } from '@cdw-ae/access-management-common-services';
import { DateFormat, Timezone } from '@cdw-ae/common-data';
import { createAction, props } from '@ngrx/store';
import { UserData } from './user-identity-settings.models';

export const initUserIdentitySettings = createAction(
  '[UserIdentitySettings Page] Init'
);

export const setUser = createAction(
  '[UserIdentity] Set User Data',
  props<{ userData: UserData | null }>()
);

export const setIdToken = createAction(
  '[UserIdentity] Set User Data without custom claims',
  props<{ userData: Omit<UserData, 'customerId'> }>()
);

export const loadPermissions = createAction('[UserIdentity] Load Permissions');

export const loadPermissionsSuccess = createAction(
  '[UserIdentity/API] Load Permissions Success',
  props<{ permissions: AccessManagementUserAuthContext }>()
);

export const loadPermissionsFailure = createAction(
  '[UserIdentity/API] Load Permissions Failure',
  props<{ error: string }>()
);

export const updateCustomerSettings = createAction(
  '[UserIdentity] Update Customer Settings',
  props<{ timezone: Timezone; dateFormat: DateFormat }>()
);

export const tokenValidationFailed = createAction(
  '[UserIdentity] Token Validation Failed',
  props<{ error: string }>()
);
